import { render } from "./App.vue?vue&type=template&id=4103a198&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4103a198&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-中北大学选课门户-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4103a198"]])

export default __exports__